import React, { useEffect, useState } from "react";
import triangle from "../Images/triangle.png";
import bloodPressure from "../Images/bloodPressure.png";
import bloodSugar from "../Images/bloodSugar.png";
import kidneyTests from "../Images/kidneyTests.png";
import liverTests from "../Images/liverTests.png";
import lipidProf from "../Images/lipidProf.png";
import bloodCount from "../Images/bloodCount.png";
import bodyTemp from "../Images/bodyTemp.png";
import heartRate from "../Images/heartRate.png";
import respRate from "../Images/respRate.png";
import oxSat from "../Images/oxSat.png";
import addPink from '../Images/addPink.png'
import { Link, useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast"

function FollowUp() {
  const [ccIndex, setCcIndex] = useState(0);
  const [medIndex, setMedIndex] = useState(0);
  const { id } = useParams()
  const [chiefComp, setChiefComp] = useState([])
  const [vitals, setVitals] = useState([])
  const [notes, setNotes] = useState([])
  const [globalEdit, setGlobalEdit] = useState(false);

  // Add these new state variables
const [complaintOptions, setComplaintOptions] = useState([]);
const [selectedDescription, setSelectedDescription] = useState("");
const [isLoadingComplaints, setIsLoadingComplaints] = useState(true);
const [searchTerm, setSearchTerm] = useState("");
const [filteredSuggestions, setFilteredSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);

  const fetchData3 = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/patients/${id}/notes/`);
      const json = await response.json();

      if (response.ok) {
        const filteredItems = json.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        setNotes(filteredItems);
        console.log('vitals', vitals);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/`);
      const json = await response.json();
      if (response.ok) {
        setChiefComp(json);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchData2 = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/`);
      const json = await response.json();
      if (response.ok) {
        setVitals(json);
        setVitalRecordId(json.vitals.id);
        console.log('vitals', vitals)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataVitalsByDate = async (vat) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/${vat}/`,
      );
      const json = await response.json();
      if (response.ok) {
        setVitals(json);
        setVitalRecordId(json.vitals.id);
        console.log("vitals per date", vitals);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {



    fetchData()
    fetchData2()
    fetchData3()
  }, [])


  const handleDateFormat = (date) => {
    const dateTimeStr = date;
    const dateObj = new Date(dateTimeStr);

    // Format the date as "22 October 2024"
    const optionsDate = { day: '2-digit', month: 'long', year: 'numeric' };
    const formattedDate = dateObj.toLocaleDateString('en-US', optionsDate);

    // Format the time as "03:27 pm"
    const optionsTime = { hour: '2-digit', minute: '2-digit', hour12: true };
    const formattedTime = dateObj.toLocaleTimeString('en-US', optionsTime);

    const dt = {
      formattedDate, formattedTime
    }

    return dt

  }

  const handleCcLeftSlide = () => {
    if (ccIndex > 0) {
      setCcIndex(ccIndex - 1);
      console.log(ccIndex);
    }
  };

  const handleCcRightSlide = () => {
    if (ccIndex < 2) {
      setCcIndex(ccIndex + 1);
      console.log(ccIndex);
    }
  };

  const handleMedLeftSlide = () => {
    if (medIndex > 0) {
      setMedIndex(medIndex - 1);
      console.log(medIndex);
    }
  };
  const handleMedRightSlide = () => {
    if (medIndex < 2) {
      setMedIndex(medIndex + 1);
      console.log(medIndex);
    }
  };


  const handleSearch = (value) => {
    setSearchTerm(value);
    
    if (!value.trim()) {
      setFilteredSuggestions([]);
      return;
    }
  
    // First prioritize searching in descriptions
    let matches = complaintOptions.filter(option => {
      const description = (option.description || option.long_description || '').toLowerCase();
      const searchLower = value.toLowerCase();
      return description.includes(searchLower);
    });
  
    // If no matches in descriptions, then search in codes as fallback
    if (matches.length === 0) {
      matches = complaintOptions.filter(option => 
        option.code.toLowerCase().includes(value.toLowerCase())
      );
    }
  
    matches.sort((a, b) => {
      const aDesc = (a.description || a.long_description || '').toLowerCase();
      const bDesc = (b.description || b.long_description || '').toLowerCase();
      const searchLower = value.toLowerCase();
      
      const aStartsWith = aDesc.startsWith(searchLower);
      const bStartsWith = bDesc.startsWith(searchLower);
      
      if (aStartsWith && !bStartsWith) return -1;
      if (!aStartsWith && bStartsWith) return 1;
      return 0;
    });
  
    setFilteredSuggestions(matches.slice(0, 10));
    setShowSuggestions(true);
  };
  
  const handleSelectSuggestion = (suggestion) => {
    setComplaintCode(suggestion.id.toString());
    setSelectedDescription(suggestion.long_description || "");
    setSearchTerm(suggestion.code);
    setShowSuggestions(false);
  };


  useEffect(() => {
    const fetchComplaintOptions = async () => {
      setIsLoadingComplaints(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/chief-complaints-options/`
        );
        if (response.ok) {
          const data = await response.json();
          setComplaintOptions(data);
        }
      } catch (error) {
        console.error("Error fetching complaint options:", error);
      } finally {
        setIsLoadingComplaints(false);
      }
    };
  
    fetchComplaintOptions();
  }, []);

  const [addNote, setAddNote] = useState('')

  const handleNote = async (e) => {
    e.preventDefault();

    const formData = {
      'content': addNote
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/patients/${id}/notes/`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const json = await response.json();
      if (response.ok) {
        console.log(json)
        fetchData3()
      }
    } catch (error) {
      console.log(error)
    }
  }


  const [ccAddNew, setCcAddNew] = useState(false)
  const [complaintCode, setComplaintCode] = useState("");
  const [ongoing, setOngoing] = useState("");
  const [onMedication, setOnMedication] = useState("");
  const [wellManaged, setWellManaged] = useState("");
  const [duration, setDuration] = useState("");
  const [sinceDate, setSinceDate] = useState("");
  const [description, setDescription] = useState("");
  const [ccEdit, setCcEdit] = useState(false)

  const [editIndex, setEditIndex] = useState(null);
  const handleComplaintCodeChange = (e) => setComplaintCode(e.target.value);
  const handleOngoingChange = (e) => setOngoing(e.target.value);
  const handleOnMedicationChange = (e) => setOnMedication(e.target.value);
  const handleWellManagedChange = (e) => setWellManaged(e.target.value);
  const handleSinceDateChange = (e) => setSinceDate(e.target.value);
  const handleDurationChange = (e) => setDuration(e.target.value);
  const handleDescriptionChange = (e) => setDescription(e.target.value);

  const handleNewCc = async (e) => {
    e.preventDefault();
    try {
      const selectedDiagnosisId = complaintOptions.find(
        (option) => option.code === searchTerm
      )?.id;
  
      const formData = {
        complaint_code: selectedDiagnosisId ? selectedDiagnosisId.toString() : complaintCode,
        ongoing: ongoing,
        on_medication: onMedication,
        well_managed: wellManaged,
        since_date: sinceDate,
        description: description
      };
  
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });
  
      if (response.ok) {
        setCcAddNew(false);
        fetchData();
        clearForm();
      }
      toast.success('Changes Saved Successfully!')

    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  const handleUpdateCc = async (e, complaintId) => {
    e.preventDefault();
    try {
      const selectedDiagnosisId = complaintOptions.find(
        (option) => option.code === searchTerm
      )?.id;
  
      const formData = {
        complaint_code: selectedDiagnosisId ? selectedDiagnosisId.toString() : complaintCode,
        ongoing: ongoing,
        on_medication: onMedication,
        well_managed: wellManaged,
        since_date: sinceDate,
        description: description
      };
  
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/chief-complaints/${id}/${complaintId}/`, {
        method: "PUT",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json"
        }
      });
  
      if (response.ok) {
        setEditIndex(null);
        fetchData();
        clearForm();
      }
      toast.success('Changes Saved Successfully!')


    } catch (error) {
      console.error("Error:", error);
    }
  };
  
  const clearForm = () => {
    setComplaintCode("");
    setOngoing("");
    setOnMedication("");
    setWellManaged("");
    setSinceDate("");
    setDescription("");
    setSearchTerm("");
    setSelectedDescription("");
  };

  const handleEditClickCc = (complaintId, complaint) => {
    setEditIndex(complaintId);
    const currentComplaint = complaintOptions.find(
      (opt) => opt.id === parseInt(complaint.complaint_code)
    );
    setSearchTerm(currentComplaint ? currentComplaint.code : "");
    setSelectedDescription(currentComplaint?.long_description || "");
    setComplaintCode(complaint.complaint_code);
    setOngoing(complaint.ongoing);
    setOnMedication(complaint.on_medication);
    setWellManaged(complaint.well_managed);
    setSinceDate(complaint.since_date);
    setDescription(complaint.description);
  };


  //Vitals
  const [sys, setSys] = useState("");
  const [dia, setDia] = useState("");

  // Blood Sugar State
  const [fastGlucose, setFastGlucose] = useState("");
  const [postGlucose, setPostGlucose] = useState("");
  const [hemoglobinA1c, setHemoglobinA1c] = useState("");

  // Kidney Function State
  const [serumCr, setSerumCr] = useState("");
  const [bun, setBun] = useState("");
  const [eGFR, setEGFR] = useState("");
  const [sodium, setSodium] = useState("");
  const [potassium, setPotassium] = useState("");

  // Liver Function State
  const [alt, setAlt] = useState("");
  const [ast, setAst] = useState("");
  const [alp, setAlp] = useState("");
  const [bilirubin, setBilirubin] = useState("");
  const [albumin, setAlbumin] = useState("");
  const [protein, setProtein] = useState("");

  // Lipid Profile State
  const [cholesterol, setCholesterol] = useState("");
  const [ldl, setLdl] = useState("");
  const [hdl, setHdl] = useState("");
  const [triglycerides, setTriglycerides] = useState("");

  // Complete Blood Count State
  const [wbc, setWbc] = useState("");
  const [rbc, setRbc] = useState("");
  const [hemoglobin, setHemoglobin] = useState("");
  const [hematocrit, setHematocrit] = useState("");
  const [platelets, setPlatelets] = useState("");
  const [mcv, setMcv] = useState("");
  const [mchc, setMchc] = useState("");

  // Body Temperature State
  const [temp, setTemp] = useState("");

  // Heart Rate State
  const [hr, setHr] = useState("");

  // Respiratory Rate State
  const [rr, setRr] = useState("");

  // Oxygen Saturation State
  const [o2Sat, setO2Sat] = useState("");

  // Assuming `vitals` is available as the provided data
  useEffect(() => {
    if (vitals && vitals.vitals) {
      // Blood Pressure
      if (vitals.vitals.blood_pressure.length > 0) {
        setSys(vitals.vitals.blood_pressure[0].systolic || "");
        setDia(vitals.vitals.blood_pressure[0].diastolic || "");
      }

      // Blood Sugar
      if (vitals.vitals.blood_sugar.length > 0) {
        setFastGlucose(vitals.vitals.blood_sugar[0].fasting_blood_glucose || "");
        setPostGlucose(vitals.vitals.blood_sugar[0].postprandial_blood_glucose || "");
        setHemoglobinA1c(vitals.vitals.blood_sugar[0].hemoglobin_A1c || "");
      }

      // Kidney Function
      if (vitals.vitals.kidney_function.length > 0) {
        setSerumCr(vitals.vitals.kidney_function[0].serum_creatinine || "");
        setBun(vitals.vitals.kidney_function[0].blood_urea_nitrogen || "");
        setEGFR(vitals.vitals.kidney_function[0].estimated_GFR || "");
        setSodium(vitals.vitals.kidney_function[0].electrolytes_sodium || "");
        setPotassium(vitals.vitals.kidney_function[0].electrolytes_potassium || "");
      }

      // Liver Function
      if (vitals.vitals.liver_function.length > 0) {
        setAlt(vitals.vitals.liver_function[0].alanine_aminotransferase || "");
        setAst(vitals.vitals.liver_function[0].aspartate_aminotransferase || "");
        setAlp(vitals.vitals.liver_function[0].alkaline_phosphatase || "");
        setBilirubin(vitals.vitals.liver_function[0].total_bilirubin || "");
        setAlbumin(vitals.vitals.liver_function[0].albumin || "");
        setProtein(vitals.vitals.liver_function[0].total_protein || "");
      }

      // Lipid Profile
      if (vitals.vitals.lipid_profile.length > 0) {
        setCholesterol(vitals.vitals.lipid_profile[0].total_cholesterol || "");
        setLdl(vitals.vitals.lipid_profile[0].LDL_cholesterol || "");
        setHdl(vitals.vitals.lipid_profile[0].HDL_cholesterol || "");
        setTriglycerides(vitals.vitals.lipid_profile[0].triglycerides || "");
      }

      // Complete Blood Count
      if (vitals.vitals.cbc.length > 0) {
        setWbc(vitals.vitals.cbc[0].white_blood_cells || "");
        setRbc(vitals.vitals.cbc[0].red_blood_cells || "");
        setHemoglobin(vitals.vitals.cbc[0].hemoglobin || "");
        setHematocrit(vitals.vitals.cbc[0].hematocrit || "");
        setPlatelets(vitals.vitals.cbc[0].platelet_count || "");
        setMcv(vitals.vitals.cbc[0].mean_corpuscular_volume || "");
        setMchc(vitals.vitals.cbc[0].mean_corpuscular_hemoglobin_concentration || "");
      }

      // Body Temperature
      if (vitals.vitals.body_temperature.length > 0) {
        setTemp(vitals.vitals.body_temperature[0].body_temperature || "");
      }

      // Heart Rate
      if (vitals.vitals.heart_rate.length > 0) {
        setHr(vitals.vitals.heart_rate[0].heart_rate || "");
      }

      // Respiratory Rate
      if (vitals.vitals.respiratory_rate.length > 0) {
        setRr(vitals.vitals.respiratory_rate[0].respiratory_rate || "");
      }

      // Oxygen Saturation
      if (vitals.vitals.oxygen_saturation.length > 0) {
        setO2Sat(vitals.vitals.oxygen_saturation[0].oxygen_saturation || "");
      }
    }
  }, [vitals]);


  // OnChange Handlers
  const handleSysChange = (e) => setSys(e.target.value);
  const handleDiaChange = (e) => setDia(e.target.value);

  const handleFastGlucoseChange = (e) => setFastGlucose(e.target.value);
  const handlePostGlucoseChange = (e) => setPostGlucose(e.target.value);
  const handleHemoglobinA1cChange = (e) => setHemoglobinA1c(e.target.value);

  const handleSerumCrChange = (e) => setSerumCr(e.target.value);
  const handleBunChange = (e) => setBun(e.target.value);
  const handleEGFRChange = (e) => setEGFR(e.target.value);
  const handleSodiumChange = (e) => setSodium(e.target.value);
  const handlePotassiumChange = (e) => setPotassium(e.target.value);

  const handleAltChange = (e) => setAlt(e.target.value);
  const handleAstChange = (e) => setAst(e.target.value);
  const handleAlpChange = (e) => setAlp(e.target.value);
  const handleBilirubinChange = (e) => setBilirubin(e.target.value);
  const handleAlbuminChange = (e) => setAlbumin(e.target.value);
  const handleProteinChange = (e) => setProtein(e.target.value);

  const handleCholesterolChange = (e) => setCholesterol(e.target.value);
  const handleLdlChange = (e) => setLdl(e.target.value);
  const handleHdlChange = (e) => setHdl(e.target.value);
  const handleTriglyceridesChange = (e) => setTriglycerides(e.target.value);

  const handleWbcChange = (e) => setWbc(e.target.value);
  const handleRbcChange = (e) => setRbc(e.target.value);
  const handleHemoglobinChange = (e) => setHemoglobin(e.target.value);
  const handleHematocritChange = (e) => setHematocrit(e.target.value);
  const handlePlateletsChange = (e) => setPlatelets(e.target.value);
  const handleMcvChange = (e) => setMcv(e.target.value);
  const handleMchcChange = (e) => setMchc(e.target.value);

  const handleTempChange = (e) => setTemp(e.target.value);

  const handleHrChange = (e) => setHr(e.target.value);

  const handleRrChange = (e) => setRr(e.target.value);

  const handleO2SatChange = (e) => setO2Sat(e.target.value);



  const [editMode, setEditMode] = useState({
    bloodPressure: false,
    bloodSugar: false,
    kidneyTests: false,
    liverTests: false,
    lipidProfile: false,
    cbc: false,
    bodyTemperature: false,
    heartRate: false,
    respiratoryRate: false,
    oxygenSaturation: false
  });

  const handleEditClick = (section) => {
    if (!globalEdit) {
      setEditMode((prevState) => ({
        ...prevState,
        [section]: !prevState[section]
      }));
    }
  };


  const handleCreateVital = async () => {
    try {
      const formData = {
        blood_pressure: [
          {
            systolic: sys,
            diastolic: dia
          }
        ],
        blood_sugar: [
          {
            fasting_blood_glucose: fastGlucose,
            postprandial_blood_glucose: postGlucose,
            hemoglobin_A1c: hemoglobinA1c
          }
        ],
        kidney_function: [
          {
            serum_creatinine: serumCr,
            blood_urea_nitrogen: bun,
            estimated_GFR: eGFR,
            electrolytes_sodium: sodium,
            electrolytes_potassium: potassium
          }
        ],
        liver_function: [
          {
            alanine_aminotransferase: alt,
            aspartate_aminotransferase: ast,
            alkaline_phosphatase: alp,
            total_bilirubin: bilirubin,
            albumin: albumin,
            total_protein: protein
          }
        ],
        lipid_profile: [
          {
            total_cholesterol: cholesterol,
            LDL_cholesterol: ldl,
            HDL_cholesterol: hdl,
            triglycerides: triglycerides
          }
        ],
        cbc: [
          {
            white_blood_cells: wbc,
            red_blood_cells: rbc,
            hemoglobin: hemoglobin,
            hematocrit: hematocrit,
            platelet_count: platelets,
            mean_corpuscular_volume: mcv,
            mean_corpuscular_hemoglobin_concentration: mchc
          }
        ],
        body_temperature: [
          {
            body_temperature: temp
          }
        ],
        heart_rate: [
          {
            heart_rate: hr
          }
        ],
        respiratory_rate: [
          {
            respiratory_rate: rr
          }
        ],
        oxygen_saturation: [
          {
            oxygen_saturation: o2Sat
          }
        ]
      };

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json"
        }
      })

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log('added vitals')
        fetchData3()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const [vitalRecordId, setVitalRecordId] = useState(0);
  const handleUpdateVital = async () => {
    try {
      const formData = {
        blood_pressure: [
          {
            systolic: Number(sys),
            diastolic: Number(dia)
          }
        ],
        blood_sugar: [
          {
            fasting_blood_glucose: Number(fastGlucose),
            postprandial_blood_glucose: Number(postGlucose),
            hemoglobin_A1c: Number(hemoglobinA1c)
          }
        ],
        kidney_function: [
          {
            serum_creatinine: Number(serumCr),
            blood_urea_nitrogen: Number(bun),
            estimated_GFR: Number(eGFR),
            electrolytes_sodium: Number(sodium),
            electrolytes_potassium: Number(potassium)
          }
        ],
        liver_function: [
          {
            alanine_aminotransferase: Number(alt),
            aspartate_aminotransferase: Number(ast),
            alkaline_phosphatase: Number(alp),
            total_bilirubin: Number(bilirubin),
            albumin: Number(albumin),
            total_protein: Number(protein)
          }
        ],
        lipid_profile: [
          {
            total_cholesterol: Number(cholesterol),
            LDL_cholesterol: Number(ldl),
            HDL_cholesterol: Number(hdl),
            triglycerides: Number(triglycerides)
          }
        ],
        cbc: [
          {
            white_blood_cells: Number(wbc),
            red_blood_cells: Number(rbc),
            hemoglobin: Number(hemoglobin),
            hematocrit: Number(hematocrit),
            platelet_count: Number(platelets),
            mean_corpuscular_volume: Number(mcv),
            mean_corpuscular_hemoglobin_concentration: Number(mchc)
          }
        ],
        body_temperature: [
          {
            body_temperature: Number(temp)
          }
        ],
        heart_rate: [
          {
            heart_rate: Number(hr)
          }
        ],
        respiratory_rate: [
          {
            respiratory_rate: Number(rr)
          }
        ],
        oxygen_saturation: [
          {
            oxygen_saturation: Number(o2Sat)
          }
        ]
      };

      console.log(formData)

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/vitals/${id}/${vitalRecordId}/`, {
        method: "PUT",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json"
        }
      })

      const json = await response.json();
      if (response.ok) {
        console.log(json);
        console.log('updated vital')
        fetchData2()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleGlobalEdit = () => {
    setGlobalEdit(true);
    // Set all edit modes to true
    setEditMode({
      bloodPressure: true,
      bloodSugar: true,
      kidneyTests: true,
      liverTests: true,
      lipidProfile: true,
      cbc: true,
      bodyTemperature: true,
      heartRate: true,
      respiratoryRate: true,
      oxygenSaturation: true
    });
  };

  const handleGlobalSave = async () => {
    setGlobalEdit(false);
    // Set all edit modes to false
    setEditMode({
      bloodPressure: false,
      bloodSugar: false,
      kidneyTests: false,
      liverTests: false,
      lipidProfile: false,
      cbc: false,
      bodyTemperature: false,
      heartRate: false,
      respiratoryRate: false,
      oxygenSaturation: false
    });

    toast.success('Changes Saved Successfully!')

    // Call the update vitals function
    try {
      await handleUpdateVital();
      fetchData2(); // Refresh the data after saving
    } catch (error) {
      console.error('Error saving vitals:', error);
    }
  };

  return (
    <div className="d2lCont">
       <Toaster/>
      <button
        className='edit-all-btn'
        onClick={() => {
          if (globalEdit) {
            handleGlobalSave();
          } else {
            handleGlobalEdit();
          }
        }}
        style={{
          backgroundColor: globalEdit ? '#f23d76' : '#393939',
          color: 'white',
          zIndex: 1000,
          padding: '1px 20px',
          border: 'none',
          borderRadius: '28px',
          width: '167px',
          height: '45px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '15px',
          /* font-weight: bold; */
          transition: 'background-color 0.3s',
          textAlign: 'center',
          filter: globalEdit ? 'drop-shadow(0px 0px 6px #f23d76)' : 'drop-shadow(0px 0px 6px #393939)'
        }}
      >
        {globalEdit ? 'Save changes' : 'Edit this section'}
      </button>
      <div className="myNotes">
    <h1>My Notes</h1>
    <div className="noteScroll">
        <div className="noteHead">
            <p>Today</p>
            <div className="line"></div>
        </div>
        <form onSubmit={handleNote}>
            <textarea
                placeholder="Start Typing..."
                className="txt"
                value={addNote}
                onChange={(e) => setAddNote(e.target.value)}
            ></textarea>
            <div className="mnBtns">
                {/* Set type="button" to prevent form submission */}
                <button type="button" onClick={() => setAddNote('')}>Clear</button>
                <button
                    type="submit"
                    style={{
                        backgroundColor: addNote === "" ? "#F4F4F4" : "#404040",
                        color: addNote === "" ? "#404040" : "#F4F4F4",
                    }}
                >
                    Save
                </button>
            </div>
        </form>

        <div className="prevNotes">
            {notes.map((note, index) => {
                const { formattedDate, formattedTime } = handleDateFormat(note.created_at);

                return (
                    <div className="prvn" key={index}>
                        <div className="noteHead">
                            <p>{formattedDate}</p>
                            <p>{formattedTime}</p>
                            <div className="line2"></div>
                        </div>
                        <p placeholder="Start Typing..." className="prevDesc">
                            {note.content}
                        </p>
                    </div>
                );
            })}
        </div>
    </div>
</div>

      <div className="d2lc">
        {/* <div className="d2lc"> */}
        <div className="ccmMain">
          <div className="ccm">
            <div className="ccmTop">
              <h1>Chief Complaints</h1>
              <div className="udb">
                <button onClick={() => setCcAddNew(!ccAddNew)}>
                  <img src={addPink} alt="addPink" /> Add New
                </button>
              </div>
            </div>
            <div className="sliderMain">
              <div className="sm cms">
                <div className="slider">
                  {chiefComp.length === 0 && <p className="noSur">No chief complaints</p>}
                  {ccAddNew && (
  <form className="slide" onSubmit={handleNewCc}>
    <button type="submit">Save</button>

    <div className="slideCont">
      <p>
        Chief Complaint:{" "}
        <>
        <div className="relative w-full">
  <input
    type="text"
    value={searchTerm}
    onChange={(e) => handleSearch(e.target.value)}
    onFocus={() => setShowSuggestions(true)}
    placeholder="Search by condition or symptoms..."
    className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
  />

  {showSuggestions && filteredSuggestions.length > 0 && (
    <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
      {filteredSuggestions.map((suggestion) => (
        <div
          key={suggestion.id}
          className="p-2 hover:bg-gray-100 cursor-pointer"
          onClick={() => handleSelectSuggestion(suggestion)}
        >
          <div className="text-sm text-gray-800">
            {suggestion.description || suggestion.long_description}
          </div>
          <div className="text-xs text-gray-500">
            Code: {suggestion.code}
          </div>
        </div>
      ))}
    </div>
  )}
</div>

          {selectedDescription && (
            <p className="complaint-description">
              <i>{selectedDescription}</i>
            </p>
          )}
        </>
      </p>
    </div>

    <div className="slideCont">
      <p>
        Ongoing:{" "}
        <input
          type="text"
          value={ongoing}
          onChange={(e) => setOngoing(e.target.value)}
          className="border-2 border-gray-300 rounded-md p-1"
        />
      </p>
      <p>
        On Medication:{" "}
        <input
          type="text"
          value={onMedication}
          onChange={(e) => setOnMedication(e.target.value)}
          className="border-2 border-gray-300 rounded-md p-1"
        />
      </p>
      <p>
        Well Managed:{" "}
        <input
          type="text"
          value={wellManaged}
          onChange={(e) => setWellManaged(e.target.value)}
          className="border-2 border-gray-300 rounded-md p-1"
        />
      </p>
    </div>

    <div className="slideCont">
      <p>
        Since When:{" "}
        <input
          type="date"
          value={sinceDate}
          onChange={(e) => setSinceDate(e.target.value)}
          className="border-2 border-gray-300 rounded-md p-1"
        />
      </p>
    </div>

    <div className="slideCont">
      <p>
        Description:{" "}
        <input
          type="text"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="chief--comp--desc"
        />
      </p>
    </div>
  </form>
)}

{chiefComp.map((cc) => (
  <form
    key={cc.id}
    className="slide"
    onSubmit={(e) => handleUpdateCc(e, cc.id)}
  >
    <button
      onClick={(e) => {
        if (editIndex === cc.id) {
          // Let form submission handle the save
        } else {
          e.preventDefault();
          handleEditClickCc(cc.id, cc);
        }
      }}
    >
      {editIndex === cc.id ? "Save" : "Edit"}
    </button>

    <div className="slideCont">
      <p>
        Chief Complaint:{" "}
        {editIndex === cc.id ? (
       <div className="relative w-full">
       <input
         type="text"
         value={searchTerm}
         onChange={(e) => handleSearch(e.target.value)}
         onFocus={() => setShowSuggestions(true)}
         placeholder="Search by condition or symptoms..."
         className="w-full p-2 border rounded focus:outline-none focus:ring-2 focus:ring-pink-500"
       />
       {showSuggestions && filteredSuggestions.length > 0 && (
         <div className="absolute z-10 w-full mt-1 bg-white border rounded-md shadow-lg max-h-60 overflow-auto">
           {filteredSuggestions.map((suggestion) => (
             <div
               key={suggestion.id}
               className="p-2 hover:bg-gray-100 cursor-pointer"
               onClick={() => handleSelectSuggestion(suggestion)}
             >
               <div className="text-sm text-gray-800">
                 {suggestion.description || suggestion.long_description}
               </div>
               <div className="text-xs text-gray-500">
                 Code: {suggestion.code}
               </div>
             </div>
           ))}
         </div>
       )}
     </div>
        ) : (
          <>
            <b>
              {complaintOptions.find(
                (opt) => opt.id === parseInt(cc.complaint_code)
              )?.code}
            </b>
            <p className="saved-complaint-details">
              <span className="complaint-description">
                {complaintOptions.find(
                  (opt) => opt.id === parseInt(cc.complaint_code)
                )?.long_description}
              </span>
            </p>
          </>
        )}
      </p>
    </div>

    <div className="slideCont">
      <p>
        Ongoing:{" "}
        {editIndex === cc.id ? (
          <input
            type="text"
            value={ongoing}
            onChange={(e) => setOngoing(e.target.value)}
            className="p-2 border rounded"
          />
        ) : (
          <b>{cc.ongoing}</b>
        )}
      </p>
      <p>
        On Medication:{" "}
        {editIndex === cc.id ? (
          <input
            type="text"
            value={onMedication}
            onChange={(e) => setOnMedication(e.target.value)}
            className="p-2 border rounded"
          />
        ) : (
          <b>{cc.on_medication}</b>
        )}
      </p>
      <p>
        Well Managed:{" "}
        {editIndex === cc.id ? (
          <input
            type="text"
            value={wellManaged}
            onChange={(e) => setWellManaged(e.target.value)}
            className="p-2 border rounded"
          />
        ) : (
          <b>{cc.well_managed}</b>
        )}
      </p>
    </div>

    <div className="slideCont">
      <p>
        Since When:{" "}
        {editIndex === cc.id ? (
          <input
            type="date"
            value={sinceDate}
            onChange={(e) => setSinceDate(e.target.value)}
            className="p-2 border rounded"
          />
        ) : (
          <b>{cc.since_date}</b>
        )}
      </p>
    </div>

    <div className="slideCont">
      <p>
        Description:{" "}
        {editIndex === cc.id ? (
          <input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="p-2 border rounded"
          />
        ) : (
          <i>{cc.description}</i>
        )}
      </p>
    </div>
  </form>
))}





                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
        {/* <div className="d2lc"> */}
        <div className="vitals ccm">
          <div className="ccmTop">
            <h1>Vitals</h1>
            <div className="udb">
            </div>
          </div>
          {vitals?.vitals ? (
            <>
              <div className="d2Links">
                {vitals.available_dates?.reverse().map((vat, index) => (
                  <div
                    className="vtDate"
                    onClick={() => fetchDataVitalsByDate(vat)} // Pass vat directly
                    key={index}
                    id={vat}
                    style={
                      vitals?.vitals?.updated_at.split('T')[0] === vat ?
                        { backgroundColor: "rgb(64, 64, 64)", color: "white" } :
                        {}
                    }
                  >
                    {vat}
                  </div>
                ))}
              </div>
              <form className="allVits" onSubmit={(e) => handleUpdateVital(e)}>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('bloodPressure')}>{editMode.bloodPressure ? "Save" : "Edit"}</button> */}
                  <img src={bloodPressure} alt="bloodPressure" />
                  <div className="vitDesc">
                    <p>
                      <b>Blood Pressure: </b>Normal
                    </p>
                    <p>
                      Systolic:{" "}
                      <span>
                        {editMode.bloodPressure ? (
                          <input
                            type="number"
                            value={sys}
                            onChange={(e) =>
                              handleSysChange(e)
                            }
                          />
                        ) : <b>
                          {vitals?.vitals?.blood_pressure?.map((bp, index) => (
                            bp.systolic
                          ))}
                        </b>}

                        mmHg
                      </span>
                    </p>
                    <p>
                      Diastolic:{" "}
                      <span>
                        {editMode.bloodPressure ? (
                          <input
                            type="number"
                            value={dia}
                            onChange={(e) =>
                              handleDiaChange(e)
                            }
                          />
                        ) : (<b>
                          {vitals?.vitals?.blood_pressure?.map((bp, index) => (
                            bp.diastolic
                          ))}
                        </b>)}

                        mmHg
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('bloodSugar')}>
                    {editMode.bloodSugar ? "Save" : "Edit"}
                  </button> */}
                  <img src={bloodSugar} alt="bloodSugar" />
                  <div className="vitDesc">
                    <p>
                      <b>Blood Sugar</b>
                    </p>
                    <p>
                      Fasting Blood Glucose:{" "}
                      <span>
                        {editMode.bloodSugar ? (
                          <input
                            type="number"
                            value={fastGlucose}
                            onChange={(e) => handleFastGlucoseChange(e)}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.blood_sugar?.map((sugar, index) => sugar.fasting_blood_glucose)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Postprandial Blood Glucose:{" "}
                      <span>
                        {editMode.bloodSugar ? (
                          <input
                            type="number"
                            value={postGlucose}
                            onChange={(e) => handlePostGlucoseChange(e)}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.blood_sugar?.map((sugar, index) => sugar.postprandial_blood_glucose)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Hemoglobin A1c:{" "}
                      <span>
                        {editMode.bloodSugar ? (
                          <input
                            type="number"
                            value={hemoglobinA1c}
                            onChange={(e) => handleHemoglobinA1cChange(e)}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.blood_sugar?.map((sugar, index) => sugar.hemoglobin_A1c)}
                          </b>
                        )}
                        %
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('kidneyTests')}>
                    {editMode.kidneyTests ? "Save" : "Edit"}
                  </button> */}
                  <img src={kidneyTests} alt="kidneyTests" />
                  <div className="vitDesc">
                    <p>
                      <b>Kidney Function Tests</b>
                    </p>
                    <p>
                      Serum Creatinine:{" "}
                      <span>
                        {editMode.kidneyTests ? (
                          <input
                            type="number"
                            value={serumCr}
                            onChange={handleSerumCrChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.kidney_function?.map((kidney, index) => kidney.serum_creatinine)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Blood Urea Nitrogen:{" "}
                      <span>
                        {editMode.kidneyTests ? (
                          <input
                            type="number"
                            value={bun}
                            onChange={handleBunChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.kidney_function?.map((kidney, index) => kidney.blood_urea_nitrogen)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Estimated GFR:{" "}
                      <span>
                        {editMode.kidneyTests ? (
                          <input
                            type="number"
                            value={eGFR}
                            onChange={handleEGFRChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.kidney_function?.map((kidney, index) => kidney.estimated_GFR)}
                          </b>
                        )}
                        mL/min/1.73 m²
                      </span>
                    </p>
                    <p>
                      Electrolytes: Sodium:{" "}
                      <span>
                        {editMode.kidneyTests ? (
                          <input
                            type="number"
                            value={sodium}
                            onChange={handleSodiumChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.kidney_function?.map((kidney, index) => kidney.electrolytes_sodium)}
                          </b>
                        )}
                        mmol/L
                      </span>
                    </p>
                    <p>
                      Electrolytes: Potassium:{" "}
                      <span>
                        {editMode.kidneyTests ? (
                          <input
                            type="number"
                            value={potassium}
                            onChange={handlePotassiumChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.kidney_function?.map((kidney, index) => kidney.electrolytes_potassium)}
                          </b>
                        )}
                        mmol/L
                      </span>
                    </p>
                  </div>
                </div>



                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('liverTests')}>
                    {editMode.liverTests ? "Save" : "Edit"}
                  </button> */}
                  <img src={liverTests} alt="liverTests" />
                  <div className="vitDesc">
                    <p>
                      <b>Liver Function Tests</b>
                    </p>
                    <p>
                      Alanine Aminotransferase:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={alt}
                            onChange={handleAltChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.alanine_aminotransferase)}
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Aspartate Aminotransferase:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={ast}
                            onChange={handleAstChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.aspartate_aminotransferase)}
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Alkaline Phosphatase:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={alp}
                            onChange={handleAlpChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.alkaline_phosphatase)}
                          </b>
                        )}
                        U/L
                      </span>
                    </p>
                    <p>
                      Total Bilirubin:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={bilirubin}
                            onChange={handleBilirubinChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.total_bilirubin)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Albumin:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={albumin}
                            onChange={handleAlbuminChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.albumin)}
                          </b>
                        )}
                        g/dL
                      </span>
                    </p>
                    <p>
                      Total Protein:{" "}
                      <span>
                        {editMode.liverTests ? (
                          <input
                            type="number"
                            value={protein}
                            onChange={handleProteinChange}
                          />
                        ) : (
                          <b>
                            {vitals?.vitals?.liver_function?.map((liver, index) => liver.total_protein)}
                          </b>
                        )}
                        g/dL
                      </span>
                    </p>
                  </div>
                </div>


                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('lipidProfile')}>
                    {editMode.lipidProfile ? "Save" : "Edit"}
                  </button> */}
                  <img src={lipidProf} alt="lipidProfile" />
                  <div className="vitDesc">
                    <p>
                      <b>Lipid Profile</b>
                    </p>
                    <p>
                      Total Cholesterol:{" "}
                      <span>
                        {editMode.lipidProfile ? (
                          <input
                            type="number"
                            value={cholesterol}
                            onChange={handleCholesterolChange}
                          />
                        ) : (
                          <b>
                            &lt;{vitals?.vitals?.lipid_profile?.map((lipid, index) => lipid.total_cholesterol)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      LDL Cholesterol:{" "}
                      <span>
                        {editMode.lipidProfile ? (
                          <input
                            type="number"
                            value={ldl}
                            onChange={handleLdlChange}
                          />
                        ) : (
                          <b>
                            &lt;{vitals?.vitals?.lipid_profile?.map((lipid, index) => lipid.LDL_cholesterol)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      HDL Cholesterol:{" "}
                      <span>
                        {editMode.lipidProfile ? (
                          <input
                            type="number"
                            value={hdl}
                            onChange={handleHdlChange}
                          />
                        ) : (
                          <b>
                            &gt;{vitals?.vitals?.lipid_profile?.map((lipid, index) => lipid.HDL_cholesterol)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                    <p>
                      Triglycerides:{" "}
                      <span>
                        {editMode.lipidProfile ? (
                          <input
                            type="number"
                            value={triglycerides}
                            onChange={handleTriglyceridesChange}
                          />
                        ) : (
                          <b>
                            &lt;{vitals?.vitals?.lipid_profile?.map((lipid, index) => lipid.triglycerides)}
                          </b>
                        )}
                        mg/dL
                      </span>
                    </p>
                  </div>
                </div>


                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('cbc')}>{editMode.cbc ? "Save" : "Edit"}</button> */}
                  <img src={bloodCount} alt="cbc" />
                  <div className="vitDesc">
                    <p>
                      <b>Complete Blood Count (CBC)</b>
                    </p>
                    <p>
                      White Blood Cells:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={wbc}
                              onChange={handleWbcChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.white_blood_cells)
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Red Blood Cells:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={rbc}
                              onChange={handleRbcChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.red_blood_cells)
                          )}
                        </b>{" "}
                        million cells/µL
                      </span>
                    </p>
                    <p>
                      Hemoglobin:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={hemoglobin}
                              onChange={handleHemoglobinChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.hemoglobin)
                          )}
                        </b>{" "}
                        g/dL
                      </span>
                    </p>
                    <p>
                      Hematocrit:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={hematocrit}
                              onChange={handleHematocritChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.hematocrit)
                          )}
                        </b>{" "}
                        %
                      </span>
                    </p>
                    <p>
                      Platelet Count:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={platelets}
                              onChange={handlePlateletsChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.platelet_count)
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Mean Corpuscular Volume:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={mcv}
                              onChange={handleMcvChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.mean_corpuscular_volume)
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                    <p>
                      Mean Corpuscular Hemoglobin Concentration:{" "}
                      <span>
                        <b>
                          {editMode.cbc ? (
                            <input
                              type="number"
                              value={mchc}
                              onChange={handleMchcChange}
                            />
                          ) : (
                            vitals?.vitals?.cbc?.map((cbc) => cbc.mean_corpuscular_hemoglobin_concentration)
                          )}
                        </b>{" "}
                        ×10³/µL
                      </span>
                    </p>
                  </div>
                </div>




                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('bodyTemperature')}>{editMode.bodyTemperature ? "Save" : "Edit"}</button> */}
                  <img src={bodyTemp} alt="bodyTemperature" />
                  <div className="vitDesc">
                    <p>
                      <b>Body Temperature</b>
                    </p>
                    <p>
                      Body Temperature:{" "}
                      <span>
                        <b>
                          {editMode.bodyTemperature ? (
                            <input
                              type="number"
                              value={temp}
                              onChange={handleTempChange}
                            />
                          ) : (
                            vitals?.vitals?.body_temperature?.map((bt) => bt.body_temperature)
                          )}
                        </b>{" "}
                        °C
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('heartRate')}>{editMode.heartRate ? "Save" : "Edit"}</button> */}
                  <img src={heartRate} alt="heartRate" />
                  <div className="vitDesc">
                    <p>
                      <b>Heart Rate (Pulse)</b>
                    </p>
                    <p>
                      Heart Rate:{" "}
                      <span>
                        <b>
                          {editMode.heartRate ? (
                            <input
                              type="number"
                              value={hr}
                              onChange={handleHrChange}
                            />
                          ) : (
                            vitals?.vitals?.heart_rate?.map((hr) => hr.heart_rate)
                          )}
                        </b>{" "}
                        bpm
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('respiratoryRate')}>{editMode.respiratoryRate ? "Save" : "Edit"}</button> */}
                  <img src={respRate} alt="respiratoryRate" />
                  <div className="vitDesc">
                    <p>
                      <b>Respiratory Rate</b>
                    </p>
                    <p>
                      Respiratory Rate:{" "}
                      <span>
                        <b>
                          {editMode.respiratoryRate ? (
                            <input
                              type="number"
                              value={rr}
                              onChange={handleRrChange}
                            />
                          ) : (
                            vitals?.vitals?.respiratory_rate?.map((rr) => rr.respiratory_rate)
                          )}
                        </b>{" "}
                        breaths per minute
                      </span>
                    </p>
                  </div>
                </div>

                <div className="slide vit">
                  {/* <button onClick={() => handleEditClick('oxygenSaturation')}>{editMode.oxygenSaturation ? "Save" : "Edit"}</button> */}
                  <img src={oxSat} alt="oxygenSaturation" />
                  <div className="vitDesc">
                    <p>
                      <b>Oxygen Saturation (SpO2)</b>
                    </p>
                    <p>
                      Oxygen Saturation:{" "}
                      <span>
                        <b>
                          {editMode.oxygenSaturation ? (
                            <input
                              type="number"
                              value={o2Sat}
                              onChange={handleO2SatChange}
                            />
                          ) : (
                            vitals?.vitals?.oxygen_saturation?.map((os) => os.oxygen_saturation)
                          )}
                        </b>{" "}
                        %
                      </span>
                    </p>
                  </div>
                </div>

              </form>
            </>
          ) :
            <div className="allVits">
              <div className="slide vit">
                <img src={bloodPressure} alt="bloodPressure" />
                <div className="vitDesc">
                  <p>
                    <b>Blood Pressure</b>
                  </p>
                  <p>
                    Systolic:{" "}
                    <input
                      type="number"
                      value={sys}
                      onChange={handleSysChange}
                    />
                    mmHg
                  </p>
                  <p>
                    Diastolic:{" "}
                    <input
                      type="number"
                      value={dia}
                      onChange={handleDiaChange}
                    />
                    mmHg
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={bloodSugar} alt="bloodSugar" />
                <div className="vitDesc">
                  <p>
                    <b>Blood Sugar</b>
                  </p>
                  <p>
                    Fasting Blood Glucose:{" "}
                    <input
                      type="number"
                      value={fastGlucose}
                      onChange={handleFastGlucoseChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Postprandial Blood Glucose:{" "}
                    <input
                      type="number"
                      value={postGlucose}
                      onChange={handlePostGlucoseChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Hemoglobin A1c:{" "}
                    <input
                      type="number"
                      value={hemoglobinA1c}
                      onChange={handleHemoglobinA1cChange}
                    />
                    %
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={kidneyTests} alt="kidney" />
                <div className="vitDesc">
                  <p>
                    <b>Kidney Function</b>
                  </p>
                  <p>
                    Serum Creatinine:{" "}
                    <input
                      type="number"
                      value={serumCr}
                      onChange={handleSerumCrChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Blood Urea Nitrogen (BUN):{" "}
                    <input
                      type="number"
                      value={bun}
                      onChange={handleBunChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Estimated GFR:{" "}
                    <input
                      type="number"
                      value={eGFR}
                      onChange={handleEGFRChange}
                    />
                    mL/min/1.73m²
                  </p>
                  <p>
                    Sodium:{" "}
                    <input
                      type="number"
                      value={sodium}
                      onChange={handleSodiumChange}
                    />
                    mEq/L
                  </p>
                  <p>
                    Potassium:{" "}
                    <input
                      type="number"
                      value={potassium}
                      onChange={handlePotassiumChange}
                    />
                    mEq/L
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={liverTests} alt="liver" />
                <div className="vitDesc">
                  <p>
                    <b>Liver Function</b>
                  </p>
                  <p>
                    ALT:{" "}
                    <input
                      type="number"
                      value={alt}
                      onChange={handleAltChange}
                    />
                    U/L
                  </p>
                  <p>
                    AST:{" "}
                    <input
                      type="number"
                      value={ast}
                      onChange={handleAstChange}
                    />
                    U/L
                  </p>
                  <p>
                    ALP:{" "}
                    <input
                      type="number"
                      value={alp}
                      onChange={handleAlpChange}
                    />
                    U/L
                  </p>
                  <p>
                    Bilirubin:{" "}
                    <input
                      type="number"
                      value={bilirubin}
                      onChange={handleBilirubinChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Albumin:{" "}
                    <input
                      type="number"
                      value={albumin}
                      onChange={handleAlbuminChange}
                    />
                    g/dL
                  </p>
                  <p>
                    Protein:{" "}
                    <input
                      type="number"
                      value={protein}
                      onChange={handleProteinChange}
                    />
                    g/dL
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={lipidProf} alt="lipidProfile" />
                <div className="vitDesc">
                  <p>
                    <b>Lipid Profile</b>
                  </p>
                  <p>
                    Total Cholesterol:{" "}
                    <input
                      type="number"
                      value={cholesterol}
                      onChange={handleCholesterolChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    LDL:{" "}
                    <input
                      type="number"
                      value={ldl}
                      onChange={handleLdlChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    HDL:{" "}
                    <input
                      type="number"
                      value={hdl}
                      onChange={handleHdlChange}
                    />
                    mg/dL
                  </p>
                  <p>
                    Triglycerides:{" "}
                    <input
                      type="number"
                      value={triglycerides}
                      onChange={handleTriglyceridesChange}
                    />
                    mg/dL
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={bloodCount} alt="cbc" />
                <div className="vitDesc">
                  <p>
                    <b>Complete Blood Count</b>
                  </p>
                  <p>
                    WBC:{" "}
                    <input
                      type="number"
                      value={wbc}
                      onChange={handleWbcChange}
                    />
                    x10³/µL
                  </p>
                  <p>
                    RBC:{" "}
                    <input
                      type="number"
                      value={rbc}
                      onChange={handleRbcChange}
                    />
                    x10⁶/µL
                  </p>
                  <p>
                    Hemoglobin:{" "}
                    <input
                      type="number"
                      value={hemoglobin}
                      onChange={handleHemoglobinChange}
                    />
                    g/dL
                  </p>
                  <p>
                    Hematocrit:{" "}
                    <input
                      type="number"
                      value={hematocrit}
                      onChange={handleHematocritChange}
                    />
                    %
                  </p>
                  <p>
                    Platelets:{" "}
                    <input
                      type="number"
                      value={platelets}
                      onChange={handlePlateletsChange}
                    />
                    x10³/µL
                  </p>
                  <p>
                    MCV:{" "}
                    <input
                      type="number"
                      value={mcv}
                      onChange={handleMcvChange}
                    />
                    fL
                  </p>
                  <p>
                    MCHC:{" "}
                    <input
                      type="number"
                      value={mchc}
                      onChange={handleMchcChange}
                    />
                    g/dL
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={bodyTemp} alt="temp" />
                <div className="vitDesc">
                  <p>
                    <b>Body Temperature</b>
                  </p>
                  <p>
                    Temperature:{" "}
                    <input
                      type="number"
                      value={temp}
                      onChange={handleTempChange}
                    />
                    °C
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={heartRate} alt="hr" />
                <div className="vitDesc">
                  <p>
                    <b>Heart Rate</b>
                  </p>
                  <p>
                    Heart Rate:{" "}
                    <input
                      type="number"
                      value={hr}
                      onChange={handleHrChange}
                    />
                    bpm
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={respRate} alt="rr" />
                <div className="vitDesc">
                  <p>
                    <b>Respiratory Rate</b>
                  </p>
                  <p>
                    Respiratory Rate:{" "}
                    <input
                      type="number"
                      value={rr}
                      onChange={handleRrChange}
                    />
                    breaths/min
                  </p>
                </div>
              </div>

              <div className="slide vit">
                <img src={oxSat} alt="o2Sat" />
                <div className="vitDesc">
                  <p>
                    <b>Oxygen Saturation</b>
                  </p>
                  <p>
                    Oxygen Saturation:{" "}
                    <input
                      type="number"
                      value={o2Sat}
                      onChange={handleO2SatChange}
                    />
                    %
                  </p>
                </div>
              </div>
            </div>
          }

        </div>
        {/* </div> */}
      </div>
    </div>
  );
}

export default FollowUp;
